import { Pipe, PipeTransform } from '@angular/core';

import { UserRolesService } from '../services/user-roles.service';

@Pipe({
    name: 'role',
    pure: false,
    standalone: false
})
export class RolePipe implements PipeTransform {
  constructor(private userRolesService: UserRolesService) { }

  transform(role: string | string[]): boolean {
    return Array.isArray(role)
      ? role.some((roleToCheck) => this.hasRole(roleToCheck))
      : this.hasRole(role);
  }

  hasRole(role: string): boolean {
    switch (role) {
      case 'admin':
        return this.userRolesService.isAdmin;

      case 'agent':
        return this.userRolesService.isAgent;

      case 'group-admin':
        return this.userRolesService.isGroupAdmin;

      case 'trainer':
        return this.userRolesService.isTrainer;

      default:
        return false;
    }
  }
}
